import { render, staticRenderFns } from "./UserFilterDropdown.vue?vue&type=template&id=a85a0208&scoped=true&"
import script from "./UserFilterDropdown.vue?vue&type=script&lang=js&"
export * from "./UserFilterDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UserFilterDropdown.vue?vue&type=style&index=0&id=a85a0208&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85a0208",
  null
  
)

export default component.exports